import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/WeeklyPicks.module.css';

function RegisterPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className={styles.container}>
      <div className={styles.formWrapper}>
        <h1 className={styles.title}>Create Account</h1>
        <p className={styles.subtitle}>Join LOTW League and start making picks!</p>

        <div className={styles.noticeMessage}>
          Registration is currently closed. Please contact the site administrator for access.
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className={styles.input}
              disabled={true}
              autoComplete="username"
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={styles.input}
              disabled={true}
              autoComplete="new-password"
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className={styles.input}
              disabled={true}
              autoComplete="new-password"
            />
          </div>

          <button
            type="submit"
            className={`${styles.primaryButton} ${styles.disabled}`}
            disabled={true}
          >
            Registration Closed
          </button>
        </form>

        <div className={styles.formFooter}>
          <p>Already have an account? <Link to="/login" className={styles.link}>Sign In</Link></p>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
